// extracted by mini-css-extract-plugin
export const outer = "dates-module--outer--3tLVr";
export const articles = "dates-module--articles--1y6Kh";
export const articles__article = "dates-module--articles__article--x-RUM";
export const animateIn = "dates-module--animateIn--1QYtk";
export const articles__link = "dates-module--articles__link--uGCAW";
export const articles__footer = "dates-module--articles__footer--1RnjY";
export const articles__content = "dates-module--articles__content--2dImx";
export const articles__contentLhs = "dates-module--articles__content-lhs--23syC";
export const articles__contentRhs = "dates-module--articles__content-rhs--SST45";
export const containerImage = "dates-module--container-image--1SakY";
export const image = "dates-module--image--2C85W";